import { Link } from 'react-router-dom';
import { ShieldCheck, FileText, ArrowLeft } from 'lucide-react';

const privacySections = [
  ['Dados coletados', 'Coletamos dados necessários para operar agendamentos: nome, telefone, e-mail quando houver pagamento Pix, serviço escolhido, barbeiro, data, horário e observações informadas pelo cliente.'],
  ['Finalidade', 'Usamos os dados para criar e gerenciar agendamentos, enviar confirmações, avisos automáticos, organizar o painel da barbearia e processar pagamentos quando solicitado.'],
  ['WhatsApp', 'O BarberFlow pode enviar mensagens automáticas relacionadas ao agendamento, como confirmação, lembretes, chegada, conclusão e solicitação de avaliação.'],
  ['Mercado Pago', 'Quando há pagamento online ou sinal, os dados necessários para gerar o Pix são enviados ao Mercado Pago. Tokens e credenciais não são expostos ao cliente.'],
  ['Cookies e sessão', 'Usamos armazenamento local e dados de sessão apenas para manter o login do painel e melhorar a navegação.'],
  ['Armazenamento e segurança', 'Os dados ficam armazenados no banco MongoDB da aplicação. Aplicamos controles básicos como autenticação, rate limit, headers de segurança e restrição de campos sensíveis nas APIs.'],
  ['Exclusão de dados', 'Clientes e barbearias podem solicitar exclusão ou correção de dados pelo suporte. Algumas informações podem ser mantidas quando forem necessárias para obrigação legal, antifraude ou histórico operacional.'],
  ['Contato', 'Para solicitações de privacidade, exclusão ou dúvidas, entre em contato pelo suporte oficial do BarberFlow.']
];

const termsSections = [
  ['Funcionamento', 'O BarberFlow fornece ferramentas para barbearias gerenciarem serviços, barbeiros, agendamentos, pagamentos, avaliações e notificações.'],
  ['Responsabilidade da barbearia', 'A barbearia é responsável por manter dados, horários, preços, serviços, barbeiros, políticas de cancelamento e canais de contato atualizados.'],
  ['Responsabilidade do cliente', 'O cliente deve informar dados corretos, comparecer no horário marcado e respeitar as regras da barbearia.'],
  ['Disponibilidade', 'Buscamos manter o sistema disponível, mas instabilidades de internet, WhatsApp, Mercado Pago, hospedagem ou serviços de terceiros podem afetar o funcionamento.'],
  ['Uso adequado', 'Não é permitido usar a plataforma para spam, fraude, conteúdo abusivo, coleta indevida de dados ou qualquer atividade ilegal.'],
  ['Pagamentos', 'Pagamentos online e sinais podem ser processados via Mercado Pago. A aprovação depende do provedor de pagamento e das regras configuradas pela barbearia.'],
  ['Cancelamentos', 'Cancelamentos e remarcações seguem as regras definidas pela barbearia. O BarberFlow registra e organiza as informações, mas não substitui acordos comerciais entre cliente e barbearia.'],
  ['Limitações', 'O BarberFlow é uma plataforma de gestão e automação. Não garante presença do cliente, qualidade do serviço prestado ou resultados comerciais específicos.']
];

export default function LegalPage({ type }) {
  const isPrivacy = type === 'privacy';
  const title = isPrivacy ? 'Política de Privacidade' : 'Termos de Uso';
  const description = isPrivacy
    ? 'Como o BarberFlow coleta, usa e protege dados pessoais.'
    : 'Regras básicas para uso da plataforma BarberFlow.';
  const sections = isPrivacy ? privacySections : termsSections;
  const Icon = isPrivacy ? ShieldCheck : FileText;

  return (
    <div className="min-h-screen bg-dark-900 text-gray-100 px-4 py-10">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-gray-400 hover:text-primary-300 mb-8">
          <ArrowLeft className="w-4 h-4" />
          Voltar
        </Link>

        <div className="card p-6 sm:p-8">
          <div className="flex items-start gap-4 mb-8">
            <div className="w-12 h-12 rounded-xl bg-primary-500/15 text-primary-300 flex items-center justify-center flex-shrink-0">
              <Icon className="w-6 h-6" />
            </div>
            <div>
              <h1 className="text-2xl sm:text-3xl font-bold text-white">{title}</h1>
              <p className="text-gray-400 mt-2">{description}</p>
              <p className="text-xs text-gray-500 mt-3">Última atualização: 20/05/2026</p>
            </div>
          </div>

          <div className="space-y-6">
            {sections.map(([heading, text]) => (
              <section key={heading}>
                <h2 className="text-lg font-semibold text-white mb-2">{heading}</h2>
                <p className="text-gray-300 leading-relaxed">{text}</p>
              </section>
            ))}
          </div>

          <div className="mt-8 pt-6 border-t border-dark-700 flex flex-wrap gap-3 text-sm">
            <Link to="/privacy" className="text-primary-300 hover:text-primary-200">Política de Privacidade</Link>
            <span className="text-gray-600">·</span>
            <Link to="/terms" className="text-primary-300 hover:text-primary-200">Termos de Uso</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
